<template>

    <div class="cbweb">
        <!-- <banner/> -->
        <Lmap/>
    </div>
</template>

<script>
    // import Banner from '@/components/Banner'
    import LMap from '@/components/LMap.vue'

    export default {
        name: 'CBWeb',
        components: {
            //'banner': Banner,
            'Lmap': LMap
        },
        data() {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    //@import '../assets/css/settings.scss';

    
</style>
